import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyTicketComponent } from './components/my-ticket/my-ticket.component';
import { MyTicketDesktopComponent } from './components/my-ticket/my-ticket-desktop/my-ticket-desktop.component';
import { MyTicketMobileComponent } from './components/my-ticket/my-ticket-mobile/my-ticket-mobile.component';
import { CoreModule } from '@ridango/core';
import { MyTicketsService } from './my-tickets.service';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule( {
    imports: [
        CommonModule,
        CoreModule,
        CoreUiModule,
        TranslateModule
    ],
    declarations: [ MyTicketComponent, MyTicketDesktopComponent, MyTicketMobileComponent ],
    exports: [ MyTicketComponent ],
    providers: [ MyTicketsService ]
} )
export class MyTicketsModule { }
